<template>
  <div class="row qandatree" v-if="QandAdata">
    <div class="col-md-12">
      <XVqanda v-for="(q, index) in QandAdata" :key="index" v-bind="q" :collapsed="collapsed"></XVqanda>
    </div>
  </div>
</template>

<script>
import { FAMixin, util } from 'pevueglobal'

export default {
  name: 'dotnetqandatree',
  props: {
    qandatype: {
      type: String,
      default: '',
    },
    courseid: {
      type: Number,
    },
    courseprofgroupid: {
      type: Number,
      default: 0,
    },
    collapsed: {},
  },
  mixins: [FAMixin],
  data() {
    return {
      QandAdata: null,
    }
  },
  created: function () {
    this.getdata()
  },
  components: {},
  methods: {
    getdata: function () {
      util
        .getDataApi('allroles/PEapi_QandA', {
          id: this.courseid,
          type: this.qandatype,
          courseprofgroupid: this.courseprofgroupid,
        })
        .then((data) => {
          if (data != null) {
            data.ds.data0.forEach((Q) => {
              Q.replymessages = {
                data: null,
                toggle: false,
                replydata: null,
              }
            })

            this.QandAdata = data.ds.data0.filter((question) => {
              return question.tblQandAOriginalMessage === null
            })
            this.QandAdata.forEach((Q2) => {
              Q2.replymessages.data = data.ds.data0.filter((tg) => tg.tblQandAOriginalMessage === Q2.tblQandAID)
            })
          }
        })
    },
  },
}
</script>
<style>
</style>
